import {
    OPEN_AREA_MODAL,
    CLOSE_AREA_MODAL,
    AREA_CREATED,
    GET_AREA_LIST,
    AREA_UPDATED
} from './area.actionsTypes';



export default function areaDetails(state = { areaList: [] }, action) {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case OPEN_AREA_MODAL:
            const returnObj = {
                ...newState,
                showModal: true
            }
            if(action.selectedArea){
                returnObj.selectedArea = action.selectedArea
            }
            return returnObj
        case CLOSE_AREA_MODAL:
            delete newState.selectedArea
            return {
                ...newState,
                showModal: false
            }
        case GET_AREA_LIST:
            return {
                ...newState,
                areaList: action.areaList
            }
        case AREA_CREATED:
            newState.areaList.push(action.area)
            return newState;
        case AREA_UPDATED:
            const areaList = newState.areaList.map(area => {
                if(area._id === action.id) {
                    return action.area
                }
                return area;
            });
            return {
                ...newState,
                areaList
            };
        default:
            return newState;
    }
}